import React from "react";
import Paper from "@material-ui/core/Paper";
import Draggable from 'react-draggable';

const DraggableDialogComponent = (props) => {
    return (
      <Draggable cancel={'[class*="MuiDialogContent-root"]'} handle="#dialog-header">
          <Paper {...props} />
      </Draggable>
    );
};

export default DraggableDialogComponent;